// Contrato de la pantalla Configuración global: tipos y constantes de UI.

export type ParamCategory = 'wizard' | 'engine' | 'collections' | 'fraud' | 'contract' | 'flags';
export type ParamKind =
    | 'minutes'
    | 'hours'
    | 'days'
    | 'months'
    | 'number'
    | 'pct'
    | 'bool'
    | 'text';

/** Valor de un parámetro en pantalla: número en unidades de UI, booleano de un flag o texto. */
export type ParamValue = number | boolean | string;

export interface SystemParam {
    /** Key real de storage (backend). */
    id: string;
    name: string;
    description: string;
    category: ParamCategory;
    kind: ParamKind;
    /** Los `pct` se guardan como fracción (0.30) y se muestran como % (30). */
    value: ParamValue;
    defaultValue: ParamValue;
    min?: number;
    max?: number;
    editable: boolean;
    lastModified: string;
    lastModifiedBy: string;
}

export const PARAM_UNIT: Record<ParamKind, string> = {
    minutes: 'min',
    hours: 'h',
    days: 'días',
    months: 'meses',
    number: '',
    pct: '%',
    bool: '',
    text: '',
};

export const CATEGORY_LABEL: Record<ParamCategory, string> = {
    wizard: 'Wizard',
    engine: 'Motor',
    collections: 'Cobranza',
    fraud: 'Fraude',
    contract: 'Contrato',
    flags: 'Feature flag',
};

/** Chip de categoría (colores `.cat-*` del mock). */
export const CATEGORY_CHIP_CLASS: Record<ParamCategory, string> = {
    wizard: 'bg-info/10 text-info',
    engine: 'bg-success/10 text-success',
    collections: 'bg-[hsl(220_40%_90%)] text-[hsl(220_40%_35%)]',
    fraud: 'bg-warning/10 text-warning',
    contract: 'bg-primary/10 text-primary',
    flags: 'bg-muted text-foreground',
};
